import { render, staticRenderFns } from "./ClubImgModal.vue?vue&type=template&id=2b2c8c56&scoped=true&"
import script from "./ClubImgModal.vue?vue&type=script&lang=ts&"
export * from "./ClubImgModal.vue?vue&type=script&lang=ts&"
import style0 from "./ClubImgModal.vue?vue&type=style&index=0&id=2b2c8c56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2c8c56",
  null
  
)

export default component.exports